import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { organizationSubscriptionFeature } from './organization-subscription.feature';
import { OrganizationSubscriptionEffects } from './organization-subscription.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(organizationSubscriptionFeature),
    EffectsModule.forFeature([OrganizationSubscriptionEffects]),
  ],
})
export class OrganizationSubscriptionModule {}
